module.exports = __webpack_public_path__ + "img/case-logo-36.51d53e5e.png";